export default "Classes\n\n<router-outlet></router-outlet>\n"